module.exports = __webpack_public_path__ + "img/nitja-kunstvisitten-500px.610d6ce6.svg";